import { render, staticRenderFns } from "./validation-alert.vue?vue&type=template&id=7ef63276&"
import script from "./validation-alert.vue?vue&type=script&lang=ts&"
export * from "./validation-alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports